import React from "react";
import styles from "./MembershipCardTitle.module.scss";

const MembershipCardTitle = ({ title = "타이틀", subTitle = "" }) => {
  const formattedSubTitle = subTitle.split("\n").map((line, index) => (
    <p key={index} className={styles.subtitleLine}>
      {line}
    </p>
  ));
  return (
    <div className={styles.container}>
      <div className={styles.titleBox}>
        <div className={styles.titleBox__borderLine} />
        <h1 className={styles.titleBox__title}>{title}</h1>
        <div className={styles.titleBox__borderLine} />
      </div>
      <h2 className={styles.container__subTitle}>{formattedSubTitle}</h2>
    </div>
  );
};

export default MembershipCardTitle;
